import BaseApi from "../base/BaseApi";

const CLIENT_ID = "867001947412.clients.hubrise.com";
const TIMEOUT = 20000;

class HubRiseAPI extends BaseApi {
  private _isDev: boolean;

  constructor(isDev: boolean = false, isPopina: boolean = true) {
    super(
      isDev
        ? isPopina
          ? "https://us-central1-popina-dev.cloudfunctions.net/api/v1/hubrise"
          : "https://us-central1-jalia-dev.cloudfunctions.net/api/v1/hubrise"
        : isPopina
        ? "https://us-central1-popina-prod.cloudfunctions.net/api/v1/hubrise"
        : "https://us-central1-jalia-prod.cloudfunctions.net/api/v1/hubrise",
      false,
      TIMEOUT
    );
    this._isDev = isDev;
  }

  public get isDev(): boolean {
    return this._isDev;
  }

  private get header(): any {
    return {
      "Content-type": "Application/json",
      Authorization: "Bearer lzPoPoiZ19OplVETRyzWyK9T5fNDiPl9",
    };
  }

  loadService = (uid: string) => {
    return this.getRequest(`/${uid}`, this.header);
  };

  connectService = (authorizationCode: string, uid: string) => {
    return this.postRequest(`/connect`, this.header, {
      authorizationCode,
      uid
    });
  };

  disconnectService = (uid: string) => {
    return this.postRequest("/disconnect", this.header, { uid });
  };

  upLoadCatalog(catalogId: string, catalog: any, uid: string) {
    return this.putRequest(
      `/catalogs/${catalogId}`,
      {
        ...this.header,
        "Content-type": "application/json"
      },
      { catalog, uid }
    );
  }

  navigateToAuthPage = (
    redirectUri: string,
    accountName: string,
    locationName: string,
    countryCode: string
  ) => {
    const hubRiseOauth2Url = `https://manager.hubrise.com/oauth2/v1/authorize?redirect_uri=${redirectUri}&client_id=${CLIENT_ID}&scope=location[orders.write,customer_list.write,catalog.write]&account_name=${accountName}&location_name=${locationName}&country=${countryCode}`;
    window.open(hubRiseOauth2Url, "_self");
  };
}

export default HubRiseAPI;
